import React, { useState, useEffect } from "react";
import DayBasisSwitch from "../../CoreComponents/DayBasisSwitch";
import { DAY_PLACED, basisParam, useRefetchOnBasis } from "../../Functionalities/dayBasis";

import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  GET_GRAPH_DATA,
  ManageDashBoard,
  ManageDashBoardOrderSummary,
} from "./Functions";

import TopComponent from "./TopComponent";
import OrdersBars from "./blocks/OrdersBars";
import CompletionDonut from "./blocks/CompletionDonut";
import {
  franchise,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_superuser,
  picked_franchise_id,
  user_id,
} from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import {
  ALL_FRANCHISES,
  franchiseParams,
  tileSet,
} from "../../Functionalities/franchisePicker";
import "./dashboard.css";
import "./dashboard-charts.css";

const franchiseId = picked_franchise_id || ALL_FRANCHISES;

function Dashboard() {
  const [Data, setData] = useState({
    is_superuser: "",
    is_franchise_user: "",
    total_orders: 0,
    todays_order: 0,
    total_users_count: 0,
    total_products_count: 0,
    total_category_count: 0,
    total_amount: 0,
    total_commission_amount: 0,
    total_remaining_amount: 0,
    total_amount_in: 0,
    total_amount_out: 0,
    total_balance_amount: 0,
    total_deliveryboys_count: 0,
    total_branch_count: 0,
    total_franchsie_count: 0,
    total_offer_count: 0,
    total_coupens_count: 0,
    total_section_count: 0,
  });

  const [orderSummary, setorderSummary] = useState({
    is_superuser: "",
    total_orders: 0,
    total_cancelled_orders: 0,
    total_average_amount: 0,
    todays_order_count: 0,
    todays_delivered_count: 0,
    todays_cancelled__count: 0,
    yesterday_order_count: 0,
    yesterday_delivered_count: 0,
    yesterday_cancelled_count: 0,
    yesterday_orders_amount: 0,
    yesterday_delivered_orders_amount: 0,
    week_order_count: 0,
    week_delivered_count: 0,
    week_cancelled_count: 0,
    month_order_count: 0,
    month_delivered_count: 0,
    month_cancelled_count: 0,
    todays_orders_amount: 0,
    week_orders_amount: 0,
    month_orders_amount: 0,
    today_delivered_orders_amount: 0,
    week_delivered_orders_amount: 0,
    month_delivered_orders_amount: 0,
  });

  const [graphData, setGraphData] = useState(null);

  const [loading, setloading] = useState(true);

  const [basis, setBasis] = useState(DAY_PLACED);

  const params = franchiseParams(is_superuser, franchiseId);
  const dateParams = [params, basisParam(basis).slice(1)].filter(Boolean).join("&");

  useRefetchOnBasis(basis, () => {
    getOrderSummary(() => true);
    getStatistics(() => true);
  });

  useEffect(() => {
    let current = true;
    setloading(true);
    getCollection(() => current);
    getOrderSummary(() => current);
    getStatistics(() => current);
    return () => {
      current = false;
    };
  }, [params]);

  const getCollection = (isCurrent) => {
    let data = ManageDashBoard("", "get", "", params);

    data.then((data) => {
      if (!isCurrent()) return;
      if (data === 0) {
      } else {
        if (!data.data.is_superuser && !data.data.is_franchise_user) {
          window.location.href = "/orders";
        }
        setData({
          is_superuser: data.data.is_superuser,
          is_franchise_user: data.data.is_franchise_user,
          total_orders: data.data.total_orders,
          todays_order: data.data.todays_order,
          total_users_count: data.data.total_users_count,
          total_products_count: data.data.total_products_count,
          total_category_count: data.data.total_category_count,
          total_amount: data.data.total_amount,
          total_commission_amount: data.data.total_commission_amount,
          total_remaining_amount: data.data.total_remaining_amount,
          total_amount_out: data.data.total_amount_out,
          total_balance_amount: data.data.total_balance_amount,
          total_deliveryboys_count: data.data.total_deliveryboys_count,
          total_branch_count: data.data.total_branch_count,
          total_franchsie_count: data.data.total_franchsie_count,
          total_offer_count: data.data.total_offer_count,
          total_coupens_count: data.data.total_coupens_count,
          total_section_count: data.data.total_section_count,
        });
        setloading(false);
      }
    });
  };

  const getStatistics = (isCurrent) => {
    let data = GET_GRAPH_DATA(dateParams);

    data
      .then((data) => {
        if (!isCurrent()) return;
        const values = data?.data?.Status === true ? data.data.values : [];
        setGraphData(Array.isArray(values) ? values : []);
      })
      .catch(() => isCurrent() && setGraphData([]));
  };

  const getOrderSummary = (isCurrent) => {
    let data = ManageDashBoardOrderSummary("", "get", "", dateParams);

    data.then((data) => isCurrent() && setorderSummary(data.data));
  };

  return (
    <>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Dashboard"} />
        <NavBar />
        {/* {(franchise.id === 1 && user_id === 87433) || franchise.id !== 1 ? ( */}
        <div className="content-body">
          <div className="container-fluid">
            {!loading ? (
              <>
                <div className="modal fade" id="addOrderModalside">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Menus</h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                        >
                          <span>×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="form-group">
                            <label className="text-black font-w500">
                              Food Name
                            </label>
                            <input type="text" className="form-control" />
                          </div>
                          <div className="form-group">
                            <label className="text-black font-w500">
                              Order Date
                            </label>
                            <input type="date" className="form-control" />
                          </div>
                          <div className="form-group">
                            <label className="text-black font-w500">
                              Food Price
                            </label>
                            <input type="text" className="form-control" />
                          </div>
                          <div className="form-group">
                            <button type="button" className="btn btn-primary">
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                {(Data?.is_franchise_user || Data?.is_superuser) && (
                  <div className="dash-kpi-grid">
                    {is_franchise_admin === false &&
                      !is_superuser === false &&
                      !is_franchise_manager === false &&
                      tileSet(is_superuser, franchiseId) !== "franchise" && (
                        <>
                          <TopComponent
                            name="Today Orders"
                            totalCount={Data.todays_order}
                          />
                          <TopComponent
                            name="Total Orders"
                            totalCount={Data.total_orders}
                          />
                          <TopComponent
                            name="Total Products"
                            totalCount={Data.total_products_count}
                          />
                          <TopComponent
                            name="Total Offer Count"
                            totalCount={Data.total_offer_count}
                          />
                        </>
                      )}

                    {(is_franchise_admin ||
                      is_franchise_manager ||
                      is_franchise_staff ||
                      tileSet(is_superuser, franchiseId) === "franchise") && (
                      <>
                        <TopComponent
                          name="Today Orders"
                          totalCount={Data.todays_order}
                        />
                        <TopComponent
                          name="Total Orders"
                          totalCount={Data.total_orders}
                        />
                        <TopComponent
                          name="Total Products"
                          totalCount={Data.total_products_count}
                        />

                        <TopComponent
                          name="Total Active Restaurants"
                          totalCount={Data.total_branch_count}
                        />
                        <TopComponent
                          name="Total Coupons"
                          totalCount={Data.total_coupens_count}
                        />
                        <TopComponent
                          name="Total Sections"
                          totalCount={Data.total_section_count}
                        />
                        <TopComponent
                          name="Total Customers"
                          totalCount={Data.total_users_count}
                        />
                        <TopComponent
                          name="Total Delivery Boys"
                          totalCount={Data.total_deliveryboys_count}
                        />
                      </>
                    )}

                    {tileSet(is_superuser, franchiseId) === "all" && (
                      <TopComponent
                        name="Today Orders"
                        totalCount={Data.todays_order}
                      />
                    )}

                    {tileSet(is_superuser, franchiseId) === "all" && (
                      <TopComponent
                        name="Total Customers"
                        totalCount={Data.total_users_count}
                      />
                    )}

                    {tileSet(is_superuser, franchiseId) === "all" && (
                      <TopComponent
                        name="Total Active Restaurants"
                        totalCount={Data.total_branch_count}
                      />
                    )}
                    {tileSet(is_superuser, franchiseId) === "all" && (
                      <TopComponent
                        name="Total Franchise"
                        totalCount={Data.total_franchsie_count}
                      />
                    )}

                    <div className="dash-kpi-tile dash-kpi-controls">
                      <DayBasisSwitch compact value={basis} onChange={setBasis} />
                    </div>
                  </div>
                )}

                <div className="row">
                  {(Data?.is_franchise_user || Data?.is_superuser) && (
                    <div className="col-xl-12">
                      <OrdersBars values={graphData} />
                    </div>
                  )}

                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
                        <div className="mr-auto pr-3">
                          <h4 className="text-black fs-20">Orders Summary</h4>
                        </div>
                        <div className="card-action card-tabs mt-3 mt-sm-0 mt-3 mb-sm-0 mb-3 mt-sm-0">
                          <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-toggle="tab"
                                href="#Today"
                                role="tab"
                                aria-selected="false"
                              >
                                Today
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#Yesterday"
                                role="tab"
                                aria-selected="false"
                              >
                                Yesterday
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-toggle="tab"
                                href="#Weekly"
                                role="tab"
                                aria-selected="false"
                              >
                                Weekly
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link "
                                data-toggle="tab"
                                href="#Monthly"
                                role="tab"
                                aria-selected="true"
                              >
                                Monthly
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="tab-content">
                          <div className="tab-pane fade show active" id="Today">
                            <CompletionDonut
                              accomplished={
                                orderSummary.today_delivered_orders_amount
                              }
                              total={orderSummary.todays_orders_amount}
                              orders={orderSummary.todays_order_count}
                              delivered={orderSummary.todays_delivered_count}
                              canceled={orderSummary.todays_cancelled__count}
                            />
                          </div>

                          <div className="tab-pane fade" id="Yesterday">
                            <CompletionDonut
                              accomplished={
                                orderSummary.yesterday_delivered_orders_amount
                              }
                              total={orderSummary.yesterday_orders_amount}
                              orders={orderSummary.yesterday_order_count}
                              delivered={orderSummary.yesterday_delivered_count}
                              canceled={orderSummary.yesterday_cancelled_count}
                            />
                          </div>

                          <div className="tab-pane fade" id="Weekly">
                            <CompletionDonut
                              accomplished={
                                orderSummary.week_delivered_orders_amount
                              }
                              total={orderSummary.week_orders_amount}
                              orders={orderSummary.week_order_count}
                              delivered={orderSummary.week_delivered_count}
                              canceled={orderSummary.week_cancelled_count}
                            />
                          </div>

                          <div className="tab-pane fade " id="Monthly">
                            <CompletionDonut
                              accomplished={
                                orderSummary.month_delivered_orders_amount
                              }
                              total={orderSummary.month_orders_amount}
                              orders={orderSummary.month_order_count}
                              delivered={orderSummary.month_delivered_count}
                              canceled={orderSummary.month_cancelled_count}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <LoadingComponent />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
